'use client'

import { ThemeColorManager } from '@/components/utility/theme-color-manager'

export function ClientThemeColorManager() {
  return <ThemeColorManager />
}
